/**
 * <Stagger> — a gated container that staggers its <StaggerItem> children in.
 *
 * Use ONLY for small (3–8 item) first-paint groups (empty states, dashboard
 * rows, settings sections). Never for long / virtualized / paginated lists, and
 * never re-mount it on update (it would re-stagger). Forwards className,
 * data-testid, and ref. Mounts statically under reduced motion.
 */
import { motion } from "framer-motion";
import { forwardRef, type Ref } from "react";

import { MOTION_TAGS, type MotionWrapperProps } from "@/components/motion/shared";
import { useGardenMotion } from "@/lib/use-garden-motion";

export const Stagger = forwardRef<HTMLElement, MotionWrapperProps>(function Stagger(
  { as = "div", className, children, "data-testid": testId },
  ref,
) {
  const { entrance } = useGardenMotion();
  const Comp = MOTION_TAGS[as] as typeof motion.div;
  return (
    <Comp
      ref={ref as Ref<HTMLDivElement>}
      className={className}
      data-testid={testId}
      {...entrance("container")}
    >
      {children}
    </Comp>
  );
});
